import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../global/primeng.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { ListboxModule } from 'primeng/listbox';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { ManageAuctionFeesComponent } from './manage-auction-fees.component';
import { ListAuctionFeesComponent } from './list-auction-fees/list-auction-fees.component';
import { AddAuctionFeesComponent } from './add-auction-fees/add-auction-fees.component';
import { EditAuctionFeesComponent } from './edit-auction-fees/edit-auction-fees.component';
import { ChangeLogAuctionFeesComponent } from './change-log-auction-fees/change-log-auction-fees.component';
import { ManageAuctionFeesService } from './manage-auction-fees.service';

@NgModule({
    declarations: [ManageAuctionFeesComponent,
        ListAuctionFeesComponent,
        AddAuctionFeesComponent,
        EditAuctionFeesComponent,
        ChangeLogAuctionFeesComponent],
    imports: [
        CommonModule,
        PrimengModule,
        SharedModule,
        FormsModule,
        DropdownModule,
        MultiSelectModule,
        ReactiveFormsModule,
        TooltipModule,
        CalendarModule,
        ListboxModule,
        BreadcrumbModule,
        ToastModule
    ],
    providers: [ManageAuctionFeesService],
    exports: [ManageAuctionFeesComponent,
                ListAuctionFeesComponent,
                AddAuctionFeesComponent,
                EditAuctionFeesComponent,
                ChangeLogAuctionFeesComponent]
})

export class ManageAuctionFeesModule { }